import {createResourceSelector} from 'src/shared/utils/resource';
export const cxpRecommendation = createResourceSelector('cxpRecommendation');
